.avatar {
	corner-shape: round;
	border-radius: 50%;
	flex-grow: 0;
	flex-shrink: 0;
}

.text {
	ascent-override: normal;
}
